// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-05-12T12:08:37+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  192125
//    Project:        617
//    Environment:    7626 - master
//    MD5:            32fe3f917217b3d46bacc700f371322d
//    Signature:      eyJpdiI6IkJoZUZQVW1xbTZ2VkZ6MmpETXg2akE9PSIsInZhbHVlIjoiRE9MMGVXNzZUdHpOaWIzYUJrTlBVWU9cLzYydXF2ZmxQS1hPalllME9rM201eFRIN2xmZ3ZxRFlncE9va3owYmhNRkh6bFJJZVBkOXlpeTJLbFwvQVhnWTlaRjlyK3BmUEFcL3l4NjFLMnpobE0ySFhLcENsamxhRVV1aWNic2ZBYjNnRmxKUHdybDI4K0lPV3lnMm5paWxTOEZVbmo5NVVQWkJyblBJNnBOR2N4XC9VaU5QV0NcLzN0N2RFN1JSXC9WbHZYSTl3V3lxczVrUk94RHgyMmRaTDkySlpVUWh3TElsaHlxcWsyWU14OGc5SFZcLzZrZHRLUDlVeTVtUmw5OUtCd0gzYk5JWjNGUTUzS0lxaVpwVE1LM3p2c0IrcUVzeElPVWRFa3BhSDkrcEY2R1krWGxcL01vU2FXSTd4SlQrK1NrR1dBdGtYV01pQ3JOMlJVeUdBV0IxNENtSFFnYWZDcXRZVWsyN0Zqdm1JZVFwZHZVM1huQnBNMTFyM2tkMmE0dG1UenJnZFNBU3N3WUNyNjcwXC9pSlFnQT09IiwibWFjIjoiYTFmMzQxYmRjZDU3N2Q3MDcyZWM4NzAxYTA4ZThmMTRhNTc0OWQ5MGZlMGIzNjUyYzJiYzc5NjcyYjJhYThmNyJ9
let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}
